import {Component, Inject, Input, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AlertService, DateUtils, JhiLanguageService} from 'ng-jhipster';
import {Formation} from './formation.model';
import {FormationService} from './formation.service';
import {Response} from '@angular/http';
import {Piece} from './piece.model';
import {PieceService} from './piece.service';
import {Observable} from 'rxjs';
import {Question} from './question.model';
import {QuestionService} from './question.service';
import {CONSTANTS} from '../../cadens.constants';
import {ListeChoix} from '../../shared/ListeChoix/listeChoix.model';
import {ListeChoixService} from '../../shared/ListeChoix/listeChoix.service';
import {JhiAlertComponent, Principal} from '../../shared';
import {PageScrollInstance, PageScrollService} from 'ng2-page-scroll';
import {DOCUMENT} from '@angular/platform-browser';
import {DemandeModif} from '../blocks/demande-modif/demande-modif.model';
import {DemandeModifService} from '../blocks/demande-modif/demande-modif.service';
import {TranslateService} from 'ng2-translate';

@Component({
    selector: 'jhi-formation-detail',
    templateUrl: './formation-detail.component.html'
})

export class FormationDetailComponent implements OnInit, OnDestroy {
    constants = CONSTANTS;
    formation = new Formation();
    formationListe: Formation[];
    pieces: Piece[];
    questions: Question[];
    pageEdition = 'informations';
    navIsFixed = false;
    reloading = false;
    currentLang: string;
    @Input() uniquementDemandeModif = false;
    demandeModifs: DemandeModif[] = [];
    formationUtiliseeDansCampagnefuture = true;
    services: ListeChoix[];
    isOnlyEnseignant = false;
    isOnlyResponsableFormation = false;
    isResponsableFormation = false;
    isAdmin = false;
    isGestionnaire = false;
    private subscription: any;
    private piecesCommunes: Piece[];
    private login: string;
    private currentAccount: any;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private formationService: FormationService,
        private pieceService: PieceService,
        private questionService: QuestionService,
        private listeChoixService: ListeChoixService,
        private route: ActivatedRoute,
        private principal: Principal,
        private router: Router,
        private alertService: AlertService,
        private demandeModifsService: DemandeModifService,
        private dateUtils: DateUtils,
        private pageScrollService: PageScrollService,
        private translateService: TranslateService,
        @Inject(DOCUMENT) private document: any
    ) {
        this.jhiLanguageService.setLocations(['formation', 'pieceJointe', 'demandeModif']);
        this.currentLang = '' + this.jhiLanguageService.currentLang;
        this.translateService.onLangChange.subscribe(lang => this.currentLang = lang.lang);
    }

    ngOnInit() {
        this.reloading = true;
        this.subscription = this.route.params.subscribe(params => {
            if (params['id'].indexOf(',') > 0) {
                this.loadAllFormations(params['id']);
            } else {
                this.loadFormation(params['id']);
            }
        });
        this.listeChoixService.query({type: CONSTANTS.SERVICE}).subscribe(services => {
            this.services = services.json();
        });

        this.principal.identity().then((account) => {
            this.currentAccount = account;
            this.isAdmin = Principal.isAdmin(account.authorities);
            this.isGestionnaire = Principal.isGestionnaire(account.authorities);
            this.isOnlyEnseignant = Principal.isOnlyEnseignant(account.authorities);
            // on regarde si la personne est responsable de la formation
            this.isOnlyResponsableFormation = Principal.isOnlyResponsableFormation(account.authorities);
            this.isResponsableFormation = Principal.isResponsableFormation(account.authorities);
            this.uniquementDemandeModif = this.isOnlyEnseignant;
        });


        this.principal.getIdentityLogin().then(login => {
            this.login = login.toString();
        });
    }


    /**
     * Sélection / Déselection d'une des formation dans la liste
     * @param formation clickée
     */
    onClickOnFormation(formation) {
        if (this.formation.id === formation.id) {
            this.formation = new Formation();
            this.displayListesComplementaires();
            this.displayPiecesCommunes(this.formationListe.map(f => f.id));
        } else {
            this.reloading = true;
            this.formation = formation;
            this.loadPiecesQuestions(formation.id);
        }
    }

    save() {
        this.reloading = true;
        // Enregistrement d'une formation
        if (this.formation.id != null) {
            let updates = [this.formationService.update(this.formation)];
            if (!this.isOnlyResponsableFormation && !this.isOnlyEnseignant && this.pieces != null && this.pieces.length > 0) {
                this.pieces.forEach(piece => piece.formationId = this.formation.id);
                updates.push(this.pieceService.update(this.pieces));
            }
            if (!this.isOnlyResponsableFormation && !this.isOnlyEnseignant && this.questions != null && this.questions.length > 0) {
                this.questions.forEach(question => question.formationId = this.formation.id);
                updates.push(this.questionService.update(this.questions));
            }

            if (this.demandeModifs != null && this.demandeModifs.length > 0) {
                this.demandeModifs.forEach(demandModif => {
                });
                updates.push(this.demandeModifsService.update(this.demandeModifs));
            }

            Observable.forkJoin(updates).subscribe((results: any[]) => {
                this.formation = results[0];
                let idx = this.formationListe.findIndex(f => f.id === this.formation.id);
                this.formationListe[idx] = this.formation;
                this.loadFormation(this.formation.id);
                this.loadPiecesQuestions(this.formation.id);
                this.formation.surbooking = (this.formation.nbPlacesSurbooking != undefined && this.formation.nbPlacesSurbooking > 0);
                this.reloading = false;
                this.alertService.success('cadensApp.formation.updated');
            }, error => {
                this.reloading = false;
                JhiAlertComponent.onError(this.alertService, error);
            });
        } else {
            // Enregistrement des infos communes sur toutes les formations de la liste
            let updates = [];
            this.formationListe.forEach(formation => {
                formation.lc = this.formation.lc;
                formation.rang = this.formation.rang;
                formation.affichageRang = this.formation.affichageRang;
                formation.users = this.formation.users;
                formation.nombreReferents = this.formation.nombreReferents;
                formation.nombreReferentsContact = this.formation.nombreReferentsContact;
                formation.nombreReferentsObligatoires = this.formation.nombreReferentsObligatoires;
                formation.lecteurs = this.formation.lecteurs;
                updates.push(this.formationService.update(formation));
            });
            this.pieces.forEach(piece => {
                let pieceCommune = this.piecesCommunes.filter(p => p.code === piece.code);
                if (pieceCommune != null && piece.id != null) {
                    pieceCommune.forEach(p => {
                        p.aide = piece.aide;
                        p.libelle = piece.libelle;
                        p.descriptif = piece.descriptif;
                        p.obligatoire = piece.obligatoire;
                    });
                    updates.push(this.pieceService.update(pieceCommune));
                } else {
                    // Create new piece for each formation
                    this.formationListe.forEach(formation => {
                        let newPiece = Object.assign({}, piece);
                        newPiece.formationId = formation.id;
                        updates.push(this.pieceService.update([newPiece]));
                    });
                }
            });
            Observable.forkJoin(updates).subscribe(results => {
                this.loadAllFormations(this.formationListe.map(f => f.id).join(','));
                this.alertService.success('cadensApp.formation.updatedAll');
            }, error => {
                this.alertService.error(error);
                this.reloading = false;
            });
        }
    }


    errorEventChange(event: String) {
        this.onErrorMessage(event, null);
    }

    public onErrorMessage(message: any, params: any) {
        JhiAlertComponent.onErrorMessage(this.alertService, message, params);
    }

    backToListe() {
        this.reloading = false;
        if (this.formation != null) {
            this.router.navigate(['/formation-back/' + this.formation.id]);
        } else {
            this.router.navigate(['/formation']);
        }
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    goToStep(step) {
        this.pageEdition = step;
        let pageScrollInstance: PageScrollInstance = PageScrollInstance.simpleInstance(this.document, '#' + step);
        this.pageScrollService.start(pageScrollInstance);
    }

    onChangeLc(newLc) {
        if (!newLc) {
            this.formation.rang = false;
            this.formation.affichageRang = false;
        }
    }

    onChangeSuppression(newLc) {
        if (this.formation.dateSuppression != null) {
            this.formation.dateSuppression = null;
        } else {
            this.formation.dateSuppression = new Date();
        }
    }

    onChangeRang(newRang) {
        if (!newRang) {
            this.formation.affichageRang = false;
        }
    }

    // noinspection JSMethodCanBeStatic
    isDeleted(formation: Formation): boolean {
        return formation.dateSuppression != null;
    }

    /**
     * In case of several formations edition, display only the pieces in common
     * @param ids of the formations
     */
    private displayPiecesCommunes(ids) {
        this.pieces = [];
        if (this.piecesCommunes.length >= ids.length) {
            // Filtrer toutes les pièces avec le même libellé
            let filteredPieces = this.piecesCommunes.filter((elem, index, self) =>
                self.findIndex(p => p.libelle === elem.libelle) === index);
            filteredPieces.forEach(piece => {
                // Si même nombre de pièces avec ce libelle qu'il y a de formations sélectionnées
                if (this.piecesCommunes.filter(p => p.libelle === piece.libelle).length === ids.length) {
                    piece.commonIds = this.piecesCommunes.filter(p => p.libelle === piece.libelle).map(p => p.id);
                    this.pieces.push(piece);
                }
            });
        }
    }

    private loadAllFormations(ids) {
        this.formationService.query({ids: ids}).subscribe((res: Response) => {
            this.formationListe = res.json();
            this.displayListesComplementaires();
            this.loadReferentsLecteurs();
            this.formationListe.forEach(formation => {
                formation.surbooking = (formation.nbPlacesSurbooking != undefined && formation.nbPlacesSurbooking > 0);
            });
            this.reloading = false;
        });
        this.pieceService.query({formationId: ids}).subscribe((res: Response) => {
            this.piecesCommunes = res.json();
            this.displayPiecesCommunes(ids.split(','));
            this.reloading = false;
        });
    }

    /**
     * Set the 3 liste complementaire booleans
     */
    private displayListesComplementaires() {
        this.formation.lc = true;
        this.formation.rang = true;
        this.formation.affichageRang = true;
        this.formation.nombreReferents = this.formationListe[0].nombreReferents;
        this.formation.nombreReferentsContact = this.formationListe[0].nombreReferentsContact;
        this.formation.nombreReferentsObligatoires = this.formationListe[0].nombreReferentsObligatoires;
        this.formationListe.forEach(formation => {
            this.formation.lc = formation.lc && this.formation.lc;
            this.formation.rang = formation.rang && this.formation.rang;
            this.formation.affichageRang = formation.affichageRang && this.formation.affichageRang;
        });
    }

    private loadFormation(id) {
        this.formationService.find(id).subscribe(formation => {
            this.formationListe = [formation];
            this.formation = formation;
            this.gereDroitFormation();
            let maintenant: Date = new Date();
            this.formationUtiliseeDansCampagnefuture = false;
            if (this.formation.campagnes.length > 0) {
                if (this.formation.campagnes.some(campagne => {
                    let ouverture = new Date(campagne.dateOuverture);
                    let fermeture = new Date(campagne.dateFermeture);
                    return ouverture >= maintenant || fermeture >= maintenant;
                })) {
                    this.formationUtiliseeDansCampagnefuture = true;
                }
            }
            this.formation.surbooking = (this.formation.nbPlacesSurbooking != undefined && this.formation.nbPlacesSurbooking > 0);
            this.reloading = false;
            this.demandeModifsService.query({
                candidatureFormationId: this.formation.id
            }).subscribe(rep => {
                let modifs: DemandeModif[] = rep.json();
                if (modifs != null) {
                    modifs.forEach(modif => {
                        modif.createdDate = this.dateUtils
                            .convertDateTimeFromServer(modif.createdDate);
                        modif.lastModifiedDate = this.dateUtils
                            .convertDateTimeFromServer(modif.lastModifiedDate);
                    });
                }
                this.demandeModifs = modifs;
            });
            this.loadPiecesQuestions(id);
        });
    }

    private gereDroitFormation() {
        if (this.isOnlyResponsableFormation && this.formation.users != null) {
            if (!this.formation.users.some(user => user.id == this.currentAccount.id)) {
                this.isOnlyEnseignant = true;
                this.isOnlyResponsableFormation = false;
                this.isResponsableFormation = false;
                this.uniquementDemandeModif = true;
            }
        }
    }

    private loadPiecesQuestions(id) {
        this.pieceService.query({formationId: id}).subscribe(
            (res: Response) => {
                this.pieces = res.json();
                this.reloading = false;
            });
        this.questionService.query({formationId: id}).subscribe(
            (res: Response) => {
                this.questions = res.json();
                this.reloading = false;
            });
    }

    /** GESTION DES ENSEIGNANTS LECTEURS ET DES REFERENTS AYANT DROITS DE PORTER DES AVIS **/
    private loadReferentsLecteurs() {
        this.formation.users = [];
        this.formation.lecteurs = [];
        let users = this.formationListe.map(f => f.users).reduce((a, b) => a.concat(b));
        let lecteurs = this.formationListe.map(f => f.lecteurs).reduce((a, b) => a.concat(b));
        this.formationListe[0].users.forEach(user => {
            let temp = users.filter(u => u.email === user.email);
            if (this.formationListe.length === temp.length) {
                this.formation.users.push(user);
            }
        });
        this.formationListe[0].lecteurs.forEach(lecteur => {
            if (this.formationListe.length === lecteurs.filter(u => u.email === lecteur.email).length) {
                this.formation.lecteurs.push(lecteur);
            }
        });
    }


}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/formation/formation-detail.component.ts